module.exports = __webpack_public_path__ + "img/img6.a2732e97.png";